enum ALIGNMENT {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}

export { ALIGNMENT }
